<template>
  <section class="content-panel">
    <div class="section-head">
      <div>
        <h2>额度流水</h2>
        <p>查看充值、扣费、调账与退款记录（单位：次）</p>
      </div>
      <div class="head-actions">
        <CustomerRemoteSelect
          v-model="customerId"
          :token="admin.token.value"
          placeholder="选择客户"
          width="200px"
          @change="onCustomerChange"
          @select="onCustomerSelect"
        />
        <el-select v-model="typeFilter" clearable placeholder="变更类型" style="width: 140px" @change="search">
          <el-option label="登录风控" value="CAP_DEDUCT" />
          <el-option label="充值" value="RECHARGE" />
          <el-option label="手动调整" value="MANUAL_ADJUST" />
          <el-option label="退款" value="REFUND" />
        </el-select>
        <el-button type="primary" :disabled="!customerId" :loading="loading" @click="search">查询</el-button>
      </div>
    </div>

    <el-table :data="logs" stripe v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="类型" width="120">
        <template #default="{ row }">
          <el-tag :type="typeTag(row.type)" effect="light">{{ typeLabel(row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="变更(次)" width="120">
        <template #default="{ row }">
          <span :class="row.amount > 0 ? 'amount-up' : 'amount-down'">
            {{ row.amount > 0 ? '+' : '' }}{{ row.amount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="变更后额度" width="120">
        <template #default="{ row }">{{ row.balanceAfter }} 次</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" />
      <el-table-column prop="operatorId" label="操作员" width="100" />
      <el-table-column label="时间" min-width="170">
        <template #default="{ row }">{{ formatTime(row.createdAt) }}</template>
      </el-table-column>
      <template #empty>
        <el-empty :description="customerId ? '暂无流水' : '请先选择客户'" />
      </template>
    </el-table>

    <div class="panel-footer">
      <el-pagination
        v-model:current-page="page"
        v-model:page-size="size"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        background
        @current-change="fetchLogs"
        @size-change="onSizeChange"
      />
    </div>
  </section>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { request } from '../services/adminApi'
import CustomerRemoteSelect from '@/components/CustomerRemoteSelect.vue'

const props = defineProps({ admin: Object })

const customerId = ref(props.admin.selectedCustomerId.value || null)
const typeFilter = ref('')
const logs = ref([])
const loading = ref(false)
const page = ref(1)
const size = ref(20)
const total = ref(0)

const typeLabel = (type) => ({
  CAP_DEDUCT: '登录风控',
  RECHARGE: '充值',
  MANUAL_ADJUST: '手动调整',
  REFUND: '退款'
}[type] || type)

const typeTag = (type) => ({
  CAP_DEDUCT: 'danger',
  RECHARGE: 'success',
  MANUAL_ADJUST: 'warning',
  REFUND: 'info'
}[type] || '')

const formatTime = (v) => (v ? new Date(v).toLocaleString('zh-CN') : '-')

async function fetchLogs() {
  if (!customerId.value) {
    logs.value = []
    total.value = 0
    return
  }
  loading.value = true
  try {
    const params = new URLSearchParams({
      page: String(page.value),
      size: String(size.value)
    })
    if (typeFilter.value) params.set('type', typeFilter.value)
    const data = await request(
      `/api/admin/customer/${customerId.value}/balance-log?${params}`,
      props.admin.token.value
    )
    logs.value = data?.records || []
    total.value = Number(data?.total || 0)
  } catch (error) {
    ElMessage.error(error.message || '加载失败')
  } finally {
    loading.value = false
  }
}

function search() {
  page.value = 1
  fetchLogs()
}

function onSizeChange() {
  page.value = 1
  fetchLogs()
}

function onCustomerChange(id) {
  customerId.value = id
  search()
}

function onCustomerSelect(item) {
  if (item) props.admin.rememberCustomers([item])
}

watch(() => props.admin.selectedCustomerId.value, (id) => {
  if (id) {
    customerId.value = id
    search()
  }
}, { immediate: true })
</script>

<style scoped>
.amount-up { color: #67c23a; }
.amount-down { color: #f56c6c; }
</style>
